import { gql } from "@apollo/client";

export const GET_COMPANY_SETTINGS = gql`
  query Settings($domain: String!) {
    company {
      settings(domain: $domain) {
        time_zone
        time_zone_label
        feed_day_start
      }
    }
  }
`

export const UPDATE_COMPANY_SETTINGS = gql`
  mutation UpdateSettings($domain: String!, $feedDayStart: String, $timeZone: CompanySettingsTimeZone) {
    company {
      updateSettings(domain: $domain, feed_day_start: $feedDayStart, time_zone: $timeZone) {
        time_zone_label
        feed_day_start
      }
    }
  }
`

export interface CompanySettings {
  time_zone?: number; // seconds offset
  time_zone_label?: string
  feed_day_start?: number; // time in minutes since midnight
}

export interface CompanySettingsResponse {
  company: {
    settings: CompanySettings
  }
}

export interface UpdateCompanySettingsResponse {
  company: {
    updateSettings: CompanySettings
  }
}